<template>
    <div class='t_content_view'>
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.corp_id" @change="changezt" clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.keyword" placeholder="请输入任务名称"  clearable />
            </div> 
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">执行时间：</span>
                <el-date-picker
                    size="small" 
                    @change="changeTime"
                    v-model="choosetime.data"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">任务状态：</span>
                <el-select size="small"
                style="width: 180px;"
                @change="searchselect"
                v-model="searchdata.status" clearable placeholder="请选择">
                    <el-option v-for="item in options.data" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
            </div> 
            
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <el-button @click="resetsearch" color="#F1F3F9" type="primary">重置</el-button>
            <el-button @click="createmsg" color="#4F46E5" type="primary">新建群发</el-button>
            <el-button @click="xianshibtn" color="#F1F3F9" type="primary">发送限时</el-button>
            <el-button @click="exportbatch" color="#F1F3F9" type="primary">批量导出明细</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column prop="title" label="任务名称"  />
            <el-table-column prop="created_at" label="创建时间" />
            <el-table-column prop="execute_at" label="执行时间" />
            <!-- <el-table-column prop="createName" label="创建成员" /> -->
            <el-table-column prop="address" label="任务状态" >
                <template #default="scope">
                    <span v-if="scope.row.status==0">待执行</span>
                    <span v-if="scope.row.status==10">执行中</span>
                    <span v-if="scope.row.status==20">执行完毕</span>
                    <span v-if="scope.row.status==25">已暂停</span>
                    <span v-if="scope.row.status==-10">执行异常终止</span>
                    <span v-if="scope.row.status==-20">执行完毕存在异常</span>
                    <span v-if="scope.row.status==-30">已过期</span>
                </template>
            </el-table-column>
            <el-table-column prop="contacts_count" label="选择好友数" />
            <el-table-column prop="sent_amount" label="送达好友数" />
            <el-table-column prop="to_send_amount">
                <template #header>
                    <el-tooltip content="任务创建时圈选的联系人数量" placement="top">
                        <span>群发人数</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="sent_failed_amount" label="失败消息数" >
                <!-- <template #default="scope">
                    <span>{{ failmsg(scope.row.selectCount,scope.row.sendCount)   }}</span>
                </template> -->
            </el-table-column>
            <el-table-column prop="address" label="操作">
                <template #default="scope">
                    <el-button style="color:#4F46E5" size="small" type="text" @click="todetail(scope.row.id)">详情</el-button>
                    <el-button style="color:#4F46E5" size="small" type="text" @click="detailbtn(scope.row.id)">删除</el-button>
                    
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
    <el-dialog v-model="overtimeshow" title="发送限时" width="500px" >
        <div style="display: flex;">
            <div>发送时间：</div>
            <div>
                <el-time-picker
                    v-model="overtime.data"
                    value-format="HH:mm:ss"
                    @change="changeovertime"
                    is-range
                    arrow-control
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
                <div style="color: #C0C0C0;font-size: 15px;margin-top: 10px;margin-bottom: 20px;">非发送时间范围内将自动停止发送</div>
            </div>
        </div>
        <div class="t_cz_box">
            <el-button @click="overtimerest" >取消</el-button>
            <el-button color="#4F46E5"  @click="overtimesub" type="primary">确定</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload ,Plus ,Close} from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { allsendlist ,xstimeadd ,xstimeedit,Delsendlist,newgetallsendlist,newgetallsendtime,neweditallsendtime,newdelallsendtime,newgetcomp2,newexportallsenduserbatch} from '@/assets/js/common.js'
//获取路由参数 
const route = useRoute()
//路由跳转
const router = useRouter()

//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    getlist()
    //获取企微主体下拉
    getcorplist()
})
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
//企微主体下拉变化
const changezt = (val)=>{
    console.log(val)
    searchdata.corp_id = val
    searchdata.page = 1
    getlist()

}
//搜索内容
const searchdata  = reactive({
    keyword:'',
    status:'',
    execute_at_start:'',
    execute_at_end:'',
    page:1,
    page_size:20,
    corp_id:''
})
//监听搜索文本框内容变化
const searchinput = (e)=>{
    console.log(e)
    searchdata.keyword = e
    searchdata.page=1
    getlist()
}
//搜索框下拉
const options = reactive({
    data:[
      {
        id:0,
        title:'待执行'
      },
      {
        id:10,
        title:'执行中'
      },
      {
        id:20,
        title:'执行完毕'
      },
      {
        id:25,
        title:'已暂停'
      },
      {
        id:-10,
        title:'执行异常终止'
      },
      {
        id:-20,
        title:'执行完毕存在异常'
      },
      {
        id:-30,
        title:'已过期'
      }
    ]
})
//监听搜索下拉变化
const searchselect = (e)=>{
    console.log(e)
    searchdata.status = e
    searchdata.page=1
    getlist()
}
//搜索时间
const choosetime = reactive({
    data:[]
})
//监听时间改变
const changeTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.execute_at_start = ''
        searchdata.execute_at_end = ''
    }else{
        searchdata.execute_at_start = e[0]
        searchdata.execute_at_end = e[1]
    }
    searchdata.page=1
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.keyword=''
    searchdata.status=''
    searchdata.page=1
    searchdata.execute_at_start = ''
    searchdata.execute_at_end = ''
    searchdata.corp_id = ''
    choosetime.data = []
    getlist()
}
//列表数据
const tableData = reactive({
    data:[]
})
//获取列表
const getlist = ()=>{
    newgetallsendlist(searchdata).then((response)=>{
        console.log('---列表')
        console.log(response.data.data)
        tableData.data = response.data.data.data
        total.value = response.data.data.total
    })
}
//成员总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//失败条数
const failmsg = (i1,i2)=>{
 return i1*1-i2*1
}
//限时数据
const overtime = reactive({
    data:[]
})
//看是否设置过时间
const isaddtime = ()=>{
    newgetallsendtime().then((response)=>{
        console.log('看是否设置过时间')
        console.log(response)
        if(response.data.data.send_start_at){
            overtime.data[0]=response.data.data.send_start_at
            overtime.data[1]=response.data.data.send_end_at
        }
    })
}
//修改限时时间
const changeovertime = (e)=>{
    console.log('--==--')
    console.log(e)
    if(e==null){
        overtime.data = []
    }
}
//发送限时弹窗
const overtimeshow = ref(false)
//打开限时弹窗
const xianshibtn = ()=>{
    //看是否设置过时间
    isaddtime()
    overtimeshow.value = true
}
//取消设置限时
const overtimerest = ()=>{
    overtimeshow.value = false
}
//提交限时时间
const overtimesub = ()=>{
    if(overtime.data.length==0){
        ElMessage.error('请选择时间')
        return
    }

    ElMessageBox.confirm(
        '是否确认提交?',
        '提示',
        {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        }
    )
    .then(() => {
        neweditallsendtime({send_start_at:overtime.data[0],send_end_at:overtime.data[1],status:1}).then((response)=>{
            console.log(response)
            ElMessage({
                type: 'success',
                message: '提交成功',
            })
            overtimeshow.value = false
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '取消',
      })
    })
}
//跳转到详情
const todetail = (id)=>{
    router.push({ path: '/navxxcd/allsenddetail', query: { 'id': id } })
}
//新建群发
const createmsg = ()=>{
    router.push({ path: '/navxxcd/creatallsend' })
}
//删除
const detailbtn = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelallsendtime({id:id}).then((response)=>{
            ElMessage({
                type: 'success',
                message: '操作成功',
            })
            //人员列表
            getlist()
        })
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//表格多选
const selectRows = ref([])
const handleSelectionChange = (rows)=>{
    selectRows.value = rows
}
//批量导出明细
const exportbatch = ()=>{
    if(selectRows.value.length==0){
        ElMessage.error('请选择要导出的任务')
        return
    }
    const task_ids = selectRows.value.map((item)=>item.id)
    newexportallsenduserbatch({ task_ids: task_ids }).then((response)=>{
        if(response.data.msg.code==0){
            const a = document.createElement('a');
            a.setAttribute('download', '');
            a.setAttribute('href', response.data.data);
            a.click();
        }else{
            ElMessage.error(response.data.msg.info)
        }
    })
}
</script>
<style scoped>


:deep(.t_search_select .select-trigger) {
    width:100%
}

:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>